import apiClient from './client';

export async function fetchUIPreferences() {
  const { data } = await apiClient.get('/api/auth/ui-preferences');
  return data;
}

export async function updateUIPreferences(patch) {
  const { data } = await apiClient.patch('/api/auth/ui-preferences', patch);
  return data;
}
